import * as v from 'valibot';
import { secret } from './domain-string.js';
import { ProfileId } from './profile.js';
import { coercedDate } from './shared.js';
export const SessionId = secret('session-id');
export const Session = v.object({
    id: SessionId,
    profileId: ProfileId,
    createdAt: coercedDate(),
    lastActiveAt: coercedDate(),
});
//# sourceMappingURL=session.js.map